import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Conteudos from "@/pages/Conteudos";
import ContentPage from "@/pages/ContentPage";
import LegalPage from "@/pages/LegalPage";
import GoogleAds from "@/components/site/GoogleAds";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Patients from "@/pages/dashboard/Patients";
import Financeiro from "@/pages/dashboard/Financeiro";
import Agenda from "@/pages/dashboard/Agenda";
import Availability from "@/pages/dashboard/Availability";
import Assistente from "@/pages/dashboard/Assistente";
import Messages from "@/pages/dashboard/Messages";
import SiteContent from "@/pages/dashboard/SiteContent";
import Prontuario from "@/pages/dashboard/Prontuario";
import SessionRoom from "@/pages/dashboard/SessionRoom";
import Security from "@/pages/dashboard/Security";
import Backup from "@/pages/dashboard/Backup";
import Seo from "@/pages/dashboard/Seo";
import SeoEdit from "@/pages/dashboard/SeoEdit";
import Integracoes from "@/pages/dashboard/Integracoes";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/esqueci-senha" element={<ForgotPassword />} />
      <Route path="/redefinir-senha/:token" element={<ResetPassword />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Overview />} />
        <Route path="pacientes" element={<Patients />} />
        <Route path="pacientes/:id" element={<Prontuario />} />
        <Route path="financeiro" element={<Financeiro />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="sala/:id" element={<SessionRoom />} />
        <Route path="disponibilidade" element={<Availability />} />
        <Route path="assistente" element={<Assistente />} />
        <Route path="mensagens" element={<Messages />} />
        <Route path="site" element={<SiteContent />} />
        <Route path="seguranca" element={<Security />} />
        <Route path="backup" element={<Backup />} />
        <Route path="seo" element={<Seo />} />
        <Route path="seo/novo" element={<SeoEdit />} />
        <Route path="seo/:id" element={<SeoEdit />} />
        <Route path="integracoes" element={<Integracoes />} />
      </Route>
      <Route path="/conteudos" element={<Conteudos />} />
      <Route path="/conteudos/:slug" element={<ContentPage />} />
      <Route path="/politica-de-privacidade" element={<LegalPage page="politica-de-privacidade" />} />
      <Route path="/termos-de-uso" element={<LegalPage page="termos-de-uso" />} />
      <Route path="/:slug" element={<ContentPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain-overlay">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
      <GoogleAds />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
